<template>
  <v-sheet elevation="0" class="h90 relative">
    <v-stepper flat v-model="tab">
      <v-row>
        <v-col>
          <BackBtn :to="routeRoot" />
        </v-col>
        <!-- <v-spacer></v-spacer> -->
        <v-col>
          <v-stepper-header>
            <v-stepper-step
              editable
              edit-icon="mdi-cogs"
              key="general"
              color="primary"
              :complete="tab >= 1"
              :step="1"
            >
              <strong class="primary--text">General</strong>
            </v-stepper-step>
            <v-divider :class="tab <= 1 ? 'grey lighten-1' : 'success'">
            </v-divider>
            <v-stepper-step
              editable
              edit-icon="mdi-view-dashboard-edit"
              key="plan"
              color="success"
              :complete="tab >= 2"
              :step="2"
            >
              <strong :class="tab >= 2 ? 'success--text' : 'grey--text'">
                Build & Run
              </strong>
            </v-stepper-step>
            <v-divider
              v-if="moduleType == PlanType.PLAN"
              :class="tab <= 2 ? 'grey lighten-1' : 'orange'"
            >
            </v-divider>
            <v-stepper-step
              v-if="moduleType == PlanType.PLAN"
              editable
              color="orange"
              edit-icon="mdi-webhook"
              key="callback"
              :complete="tab >= 3"
              :step="3"
            >
              <strong :class="tab == 3 ? 'orange--text' : 'grey--text'">
                Hooks
              </strong>
            </v-stepper-step>
          </v-stepper-header>
        </v-col>
        <!-- <v-spacer></v-spacer> -->
        <v-col>
          <v-row class="justify-end">
            <v-col class="px-1 pt-4" cols="auto">
              <Tooltip
                content="Record a Test Case"
                :altContent="
                  false
                    ? 'Pine3 extension is coming soon'
                    : 'Please install Pine3 extension at: URL'
                "
                left
                :active="extension && false"
                color="red accent-2"
                icon="microphone"
              >
                <v-btn
                  fab
                  x-small
                  :dark="extension && false"
                  :disabled="!extension || true"
                  label="Record Test Case"
                  color="red accent-2"
                  @click="preperRecorder"
                >
                  <v-icon dark> mdi-microphone </v-icon>
                </v-btn>
              </Tooltip>
            </v-col>

            <v-col
              class="px-2 pt-3"
              cols="auto"
              v-if="!newPlan && debuggerOpen && debuggerRunning"
            >
              <v-progress-circular
                :rotate="-90"
                :size="40"
                :width="5"
                :value="compareTestResults"
                color="success"
              >
                <strong>
                  <small>{{ compareTestResults }}% </small>
                </strong>
              </v-progress-circular>
            </v-col>
            <v-col
              class="px-2 pt-4"
              cols="auto"
              v-if="!newPlan && !(debuggerOpen && debuggerRunning)"
            >
              <Tooltip
                :active="!newPlan && !(debuggerOpen && debuggerRunning)"
                content="Run Test Case"
                bottom
                icon="play"
              >
                <v-btn
                  fab
                  x-small
                  :disabled="
                    newPlan ||
                    changed ||
                    (debuggerOpen && debuggerRunning) ||
                    updating
                  "
                  :label="debuggerOpen ? 'Replay Test Case' : 'Play Test Case'"
                  color="primary"
                  @click="runPlan"
                >
                  <v-icon dark>
                    mdi-{{ debuggerOpen ? "replay" : "play" }}
                  </v-icon>
                </v-btn>
              </Tooltip>
            </v-col>
            <v-col class="ml-5 px-1" cols="auto" v-if="!newPlan">
              <Tooltip
                :active="valid && changed && !debuggerRunning"
                content="Update Test Case"
                left
                color="info"
              >
                <v-btn
                  :disabled="!valid || !changed || debuggerRunning"
                  :loading="updating"
                  fab
                  small
                  label="update"
                  color="info"
                  @click="update"
                >
                  <v-icon dark small> mdi-content-save </v-icon>
                </v-btn>
              </Tooltip>
            </v-col>
            <v-col
              class="px-1"
              cols="auto"
              v-if="isSuper && moduleType != PlanType.TEMPLATE"
            >
              <Tooltip
                :active="valid && !changed && !debuggerRunning"
                content="Generate Template"
                bottom
                color="teal"
              >
                <v-btn
                  :disabled="!valid || changed || debuggerRunning"
                  :dark="valid && !changed && !debuggerRunning"
                  :loading="updating"
                  fab
                  small
                  label="Generate Template"
                  color="teal"
                  @click="genTemplate"
                >
                  <v-icon dark small> mdi-application-export </v-icon>
                </v-btn>
              </Tooltip>
            </v-col>
            <v-col class="pl-1 mr-1" cols="auto">
              <Tooltip
                :active="valid"
                content="Save Test Case & exit"
                left
                color="success"
              >
                <v-btn
                  fab
                  small
                  :disabled="!valid"
                  label="Save"
                  color="success"
                  @click="save"
                >
                  <v-icon dark> mdi-content-save-move </v-icon>
                </v-btn>
              </Tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-stepper-items>
        <v-stepper-content key="general" step="1">
          <v-row class="justify-center">
            <v-col md="10" xl="8">
              <v-card class="my-1 pb-4" elevation="4">
                <v-row class="ma-1">
                  <v-col class="ma-1 scrollable h60">
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="plan.name"
                          :label="`${identity} Name`"
                          :rules="rules.text"
                          required
                        >
                        </v-text-field>
                      </v-col>
                      <KnobBtn
                        text="Active"
                        icon="power"
                        v-model="plan.active"
                      />
                    </v-row>
                    <v-row v-if="moduleType == PlanType.PLAN">
                      <v-col>
                        <v-text-field
                          v-model="plan.version"
                          label="Version"
                          dense
                          hide-details
                          required
                        >
                        </v-text-field>
                      </v-col>
                      <v-col>
                        <v-autocomplete
                          v-model="plan.label"
                          :items="labels"
                          label="Label"
                          dense
                          hide-details
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-textarea
                          solo
                          v-model="plan.desc"
                          label="Description"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <v-row class="mt-1" v-if="plan._id">
                      <v-col>
                        <v-text-field
                          v-model="plan._id"
                          disabled
                          :label="`${identity} Identifier`"
                          required
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="auto">
                        <CopyToClip :text="plan._id" />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-divider vertical> </v-divider>
                  <v-col>
                    <h4 class="my-3">
                      <v-icon>mdi-cookie-cog</v-icon> Options:
                    </h4>
                    <div class="scrollable h50 py-1">
                      <EnvSettings
                        v-model="plan"
                        @input="planChanged"
                        :isRoutine="isRoutine"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-stepper-content>
        <v-stepper-content key="plan" step="2">
          <v-row class="justify-center mt-0">
            <!-- <v-col cols="auto">
              <v-card elevation="4">
                <v-card-text>
                  <div>
                    <v-autocomplete label="Search"></v-autocomplete>
                  </div>
                  <div class="mb-2">
                    <v-btn color="info">Misc</v-btn>
                    <v-btn color="success">User</v-btn>
                    <v-btn color="orange" dark>Assersions</v-btn>
                  </div>
                  <v-divider></v-divider>
                  <div class="ma-1" draggable>
                    <v-icon>mdi-mouse</v-icon> click <v-icon>mdi-drag</v-icon>
                  </div>
                  <div class="ma-1" draggable>
                    <v-icon>mdi-mouse</v-icon> click <v-icon>mdi-drag</v-icon>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="auto">
              <v-card elevation="0">
                <v-row>
                  <v-col>
                    <Tooltip content="Add UI starting point" top>
                      <v-btn
                        @click="addNew(1)"
                        color="blue"
                        x-small
                        fab
                        elevation="4"
                        dark
                        label="UI Test"
                      >
                        <v-icon small>mdi-flask-plus-outline</v-icon>
                      </v-btn>
                    </Tooltip></v-col
                  >
                </v-row>
                <v-row>
                  <v-col>
                    <Tooltip
                      content="Add API starting point"
                      color="purple"
                      top
                    >
                      <v-btn
                        color="purple"
                        @click="addNew(0)"
                        x-small
                        elevation="4"
                        dark
                        fab
                        label="API Test"
                      >
                        <v-icon>mdi-server-plus</v-icon>
                      </v-btn>
                    </Tooltip></v-col
                  >
                </v-row>
                <v-row>
                  <v-col>
                    <Tooltip
                      content="Upload steps from other test plan"
                      color="green"
                      bottom
                    >
                      <v-btn
                        dark
                        x-small
                        fab
                        color="green"
                        @click.stop="importDialog = true"
                      >
                        <v-icon dark> mdi-cloud-upload </v-icon>
                      </v-btn>
                    </Tooltip></v-col
                  >
                </v-row>
              </v-card>
            </v-col> -->
            <v-col>
              <!-- <ResultStats :result="results" /> -->
              <v-card
                class="scrollable h70 my-1 pb-2"
                id="planning"
                elevation="4"
                outlined
              >
                <v-row>
                  <v-col :cols="debuggerOpen ? 8 : null">
                    <h4 class="pa-1 mt-2" color="info">
                      <v-icon>mdi-flag</v-icon> Start
                    </h4>
                    <v-timeline
                      class="section mb-5"
                      align-top
                      dense
                      v-if="plan.steps && plan.steps.length"
                    >
                      <time-line-test
                        v-for="(step, index) in plan.steps"
                        :key="index"
                        :pos="[index]"
                        :test="step"
                        :last="index == plan.steps.length - 1"
                        @duplicate="addChild"
                      />
                      <v-card
                        class="actions2"
                        elevation="0"
                        color="transparent"
                      >
                        <Tooltip content="Add UI starting point" top>
                          <v-btn
                            class="mx-1"
                            @click="addNew(1)"
                            color="blue"
                            x-small
                            fab
                            elevation="4"
                            dark
                            label="UI Test"
                          >
                            <v-icon small>mdi-flask-plus-outline</v-icon>
                          </v-btn>
                        </Tooltip>
                        <Tooltip
                          content="Add API starting point"
                          color="purple"
                          top
                        >
                          <v-btn
                            class="mx-1"
                            color="purple"
                            @click="addNew(0)"
                            x-small
                            elevation="4"
                            dark
                            fab
                            label="API Test"
                          >
                            <v-icon>mdi-server-plus</v-icon>
                          </v-btn>
                        </Tooltip>
                        <Tooltip
                          content="Import a Test Routine starting point"
                          color="indigo"
                          top
                        >
                          <v-btn
                            class="mx-1"
                            color="indigo"
                            @click="openRoutineImportDialog"
                            x-small
                            elevation="4"
                            dark
                            fab
                          >
                            <v-icon>mdi-cog-clockwise</v-icon>
                          </v-btn>
                        </Tooltip>
                        <Tooltip
                          content="Import Test Case's steps starting point"
                          color="green"
                          top
                        >
                          <v-btn
                            dark
                            x-small
                            fab
                            color="green"
                            @click.stop="openPlanImportDialog"
                          >
                            <v-icon dark> mdi-cloud-upload </v-icon>
                          </v-btn>
                        </Tooltip>
                      </v-card>
                    </v-timeline>
                    <v-card-subtitle class="text-center" v-else>
                      <h3 class="h6 py-3">
                        <v-icon class="mt-n2">mdi-view-dashboard-edit</v-icon>
                        Start Building..
                      </h3>
                      <h3 class="h6 py-2 info--text">Where to start?</h3>
                      <v-row class="mt-2">
                        <v-spacer> </v-spacer>
                        <v-col cols="auto">
                          <Tooltip content="Start with UI step" bottom>
                            <v-btn
                              dark
                              small
                              fab
                              color="blue"
                              @click="addNew()"
                            >
                              <v-icon dark> mdi-flask-plus-outline </v-icon>
                            </v-btn>
                          </Tooltip>
                        </v-col>
                        <v-col cols="auto">
                          <Tooltip
                            content="Start with API step"
                            color="purple"
                            bottom
                          >
                            <v-btn
                              dark
                              small
                              fab
                              color="purple"
                              @click="addNew(0)"
                            >
                              <v-icon dark> mdi-server </v-icon>
                            </v-btn>
                          </Tooltip>
                        </v-col>
                        <v-col cols="auto">
                          <Tooltip
                            content="Import a Test Routine starting point"
                            color="indigo"
                            bottom
                          >
                            <v-btn
                              class="mx-1"
                              color="indigo"
                              @click="openRoutineImportDialog"
                              small
                              dark
                              fab
                            >
                              <v-icon>mdi-cog-clockwise</v-icon>
                            </v-btn>
                          </Tooltip>
                        </v-col>
                        <v-col cols="auto">
                          <Tooltip
                            content="Import Test Case's steps starting point"
                            color="green"
                            bottom
                          >
                            <v-btn
                              dark
                              small
                              fab
                              color="green"
                              @click.stop="openPlanImportDialog"
                            >
                              <v-icon dark> mdi-cloud-upload </v-icon>
                            </v-btn>
                          </Tooltip>
                        </v-col>
                        <v-spacer> </v-spacer>
                      </v-row>
                    </v-card-subtitle>
                  </v-col>
                  <!-- <v-slide-x-reverse-transition>
                    <v-col cols="6" v-if="debuggerOpen">
                      <debugger
                        :plan="plan"
                        :cancelTokenSource="cancelToken"
                        :loading="loading || debuggerRunning"
                      />
                    </v-col>
                  </v-slide-x-reverse-transition> -->
                </v-row>
              </v-card>
              <v-progress-linear
                v-if="debuggerRunning"
                :value="compareTestResults"
                background-opacity="0.6"
                height="15"
                color="success"
              >
                <strong class="white--text caption font-weight-bold">
                  {{ progressText }} {{ Math.ceil(compareTestResults) }}%
                </strong>
              </v-progress-linear>
            </v-col>
            <v-slide-x-reverse-transition>
              <v-col v-if="results.stats" cols="auto">
                <ResultStats :result="results" />
              </v-col>
            </v-slide-x-reverse-transition>
          </v-row>
        </v-stepper-content>
        <v-stepper-content key="callback" step="3">
          <v-row class="justify-center">
            <v-col :md="10">
              <v-card class="my-1 pa-4">
                <!-- <h4><v-icon class="mx-1">mdi-webhook</v-icon> Hooks</h4>
                <v-card-title class="px-3 text-body-2" outlined>
                  Integrating <strong><v-icon>mdi-webhook</v-icon> Hooks</strong> will
                </v-card-title> -->
                <v-row class="mt-2">
                  <v-col>
                    <v-row class="justify-center my-2">
                      <h4>
                        <v-icon color="success" class="mx-1"
                          >mdi-check-all</v-icon
                        >
                        Passed Hooks List
                      </h4>
                    </v-row>
                    <DragList
                      removable
                      values
                      :list="passHooks"
                      @changed="updatePassHooksList"
                    >
                      <template v-slot:title>
                        <v-icon small>mdi-order-bool-descending</v-icon>
                        Hooks Order:
                      </template>
                    </DragList>
                    <v-btn text color="success" @click="openHooksDialog()">
                      <v-icon>mdi-plus-circle</v-icon> add hook
                    </v-btn>
                  </v-col>
                  <!-- <v-divider vertical></v-divider> -->
                  <v-col>
                    <v-row class="justify-center my-2">
                      <h4>
                        <v-icon color="error" class="mx-1">
                          mdi-alert-octagram
                        </v-icon>
                        Failed Hooks List
                      </h4>
                    </v-row>
                    <DragList
                      removable
                      values
                      :list="failHooks"
                      @changed="updateFailHooksList"
                    >
                      <template v-slot:title>
                        <v-icon small>mdi-order-bool-descending</v-icon>
                        Hooks Order:
                      </template>
                    </DragList>
                    <v-btn text color="error" @click="openHooksDialog('fail')">
                      <v-icon>mdi-plus-circle</v-icon> add hook
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <small class="mt-2 blue--text">
                      <strong>
                        Hooks are initiated when the current Test Case is
                        complete. <br />
                        Hooks are related to the Test Case status, and can
                        trigger different hooks for 'Fail' or 'Pass' Test Case's
                        status.<br />
                        For example: <br />
                        'In case of Test Case's failure -> send email to a
                        contact from contact list'<br />
                        You can also choose the order of the hooks initiation.
                      </strong>
                    </small>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <NextBtn
      :tab="tab"
      :plan="plan"
      :notPlan="moduleType != PlanType.PLAN"
      :next="tab == (moduleType != PlanType.PLAN ? 2 : 3) ? save : next"
      @changed="tabUpdate"
    />
    <v-fab-transition>
      <v-btn
        fab
        dark
        x-small
        color="info"
        fixed
        bottom
        @click="helper = !helper"
      >
        <v-icon size="25">mdi-information-variant</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-card class="helper pa-0 my-5" elevation="10" v-if="helper">
      <v-btn absolute right text fab x-small dense @click="helper = false">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      <v-icon>mdi-information</v-icon> Usage & information
      <v-list subheader>
        <v-list-item>
          <small>
            - Every first step is a starting point, therefore - it's children
            inherit its flow and context</small
          >
        </v-list-item>
        <v-list-item>
          <small>
            - You are able to use Plan's environment variables inside steps with
            ${{}} syntax. <br />for example: <br />
            URL variable name should be used as
            <span v-html="'$&#123;&#123; URL &#125;&#125;'"> </span>
          </small>
        </v-list-item>
        <v-list-item>
          <small>
            - You are able to import other Test Case's steps at the first steps
            level using the
            <v-btn
              :dark="plan.name.length > 0"
              x-small
              fab
              :disabled="!plan.name"
              color="green"
              @click.stop="openPlanImportDialog"
            >
              <v-icon dark color="#FFF"> mdi-cloud-upload </v-icon>
            </v-btn>
            button.
          </small>
        </v-list-item>
        <v-list-item>
          <small
            >- Hooks are initiated when the current Test Case is complete.
            <br />
            Hooks are related to the Test Case status, and can trigger different
            hooks for 'Fail' or 'Pass' Test Case's status.<br />
            For example: <br />
            'In case of Test Case's failure -> send email to a contact from
            contact list'<br />
            You can also choose the order of the hooks initiation.
          </small>
        </v-list-item>
      </v-list>
    </v-card>
    <ImportModal />
    <v-dialog v-model="hooksDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5 text-center">
          <p class="fw text-capitalize">
            <v-icon color="orange" class="mr-1"> mdi-webhook </v-icon>
            Add
            <strong
              :class="
                (hooksCondition == 'pass' ? 'success' : 'error') + '--text'
              "
              >{{ hooksCondition }}ed</strong
            >
            Hook Action
          </p>
        </v-card-title>

        <v-card-text>
          <v-col>
            <v-row>
              <v-col>
                <v-select
                  :items="hooksList"
                  :prepend-icon="
                    hooksMethod === 'plan' ? 'mdi-flask' : 'mdi-send'
                  "
                  label="Hook Method"
                  v-model="hooksMethod"
                  outlined
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="auto">
                <Tooltip
                  content="Choose the condition/status for the callback to be triggered"
                  top
                  color="orange"
                >
                  <v-btn-toggle
                    v-model="hooksCondition"
                    :color="hooksCondition === 'pass' ? 'success' : 'error'"
                    dense
                    group
                    mandatory
                    label=""
                  >
                    <v-btn icon value="fail">
                      <v-icon>mdi-alert-octagram</v-icon>
                      <!-- Failed -->
                    </v-btn>
                    <v-btn icon value="pass">
                      <v-icon>mdi-check-all</v-icon>
                      <!-- Passed -->
                    </v-btn>
                  </v-btn-toggle>
                </Tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-combobox
                  :items="hooksItems"
                  :prepend-icon="
                    hooksMethod === 'plan'
                      ? 'mdi-test-tube'
                      : 'mdi-card-account-mail'
                  "
                  v-model="selectedHooks"
                  :label="
                    (hooksMethod === 'plan' ? 'Test Case' : 'Contacts') +
                    ' Hook List '
                  "
                  outlined
                  clearable
                  multiple
                  dense
                >
                  <template slot="prepend-item">
                    <v-btn
                      text
                      block
                      small
                      color="light-blue"
                      @click="routeTo(hooksMethod)"
                    >
                      <v-icon small>mdi-plus</v-icon> Create new
                      {{
                        hooksMethod === "plan" ? "Test Case" : "Contacts"
                      }}</v-btn
                    >
                  </template>
                </v-combobox>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>

        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn color="red darken-1" text @click="hooksDialog = false">
            Cancel
          </v-btn>
          <v-spacer> </v-spacer>
          <v-btn
            color="orange"
            :dark="selectedHooks.length > 0"
            @click="addHook()"
            :disabled="!selectedHooks.length"
          >
            <v-icon small> mdi-webhook </v-icon> Add Hook
          </v-btn>
          <v-spacer> </v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="recordDialog" max-width="320">
      <v-card>
        <v-card-title class="text-h5">
          <h5>Insert URL to start recording</h5>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="recordingURL"
            label="Recording URL"
            outlined
            clearable
            dense
          >
          </v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer> </v-spacer>

          <v-btn color="red darken-1" text @click="recordDialog = false">
            Cancel
          </v-btn>
          <v-spacer> </v-spacer>
          <v-btn
            color="success"
            @click="startRecording(recordingURL)"
            :disabled="!validateURL"
          >
            <v-icon dark small> mdi-microphone </v-icon> Start Recording
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ExitModal :msg="`Discard ${identity} changes?`" />
  </v-sheet>
</template>

<script lang="ts">
/* eslint-disable */
import Vue from "vue";
import { v4 } from "uuid";
import {
  capitalize,
  cloneObj,
  objNotEmpty,
  regexes,
  reId,
  scrollToID,
} from "../utils";

import BackBtn from "../components/buttons/BackBtn.vue";
import Device from "../components/Device.vue";
import Tooltip from "../components/Tooltip.vue";
import DragList from "../components/DragList.vue";
import {
  ContactItem,
  Msg,
  Plan,
  PlanType,
  RoleType,
  SelectItem,
  Step,
  StepType,
} from "../types";
import { parseEnv, flatRecursive } from "../utils";
import { DefaultStep } from "@/defaults";
import Debugger from "../components/DebuggerView.vue";
import CopyToClip from "../components/CopyToClip.vue";
import Countries from "@/components/Countries.vue";
import Locale from "@/components/Locale.vue";
import { genCancelToken } from "../utils/fetcher";
import { CancelTokenSource } from "axios";
import NextBtn from "@/components/buttons/NextBtn.vue";

import { io } from "socket.io-client";
import config from "@/config";
import RequestHeaders from "@/components/RequestHeaders.vue";
import AddList from "@/components/AddList.vue";
import ExitModal from "@/components/dialogs/ExitModal.vue";
import ImportModal from "@/components/dialogs/ImportModal.vue";
import EnvSettings from "@/components/EnvSettings.vue";
import ResultStats from "@/components/ResultStats.vue";
import KnobBtn from "@/components/buttons/KnobBtn.vue";

export default Vue.extend({
  name: "PlanView",
  components: {
    BackBtn,
    Device,
    Locale,
    Tooltip,
    DragList,
    Debugger,
    CopyToClip,
    Countries,
    NextBtn,
    RequestHeaders,
    AddList,
    ExitModal,
    ImportModal,
    EnvSettings,
    ResultStats,
    KnobBtn,
  },
  data() {
    return {
      loading: false,
      updating: false,
      device: false,
      editTitle: false,
      moduleType: 0,
      PlanType,
      identity: "",
      routeRoot: "",
      testType: PlanType.PLAN,
      rules: {
        text: [(val: string) => val.length || "This field is required"],
      },
      helper: false,
      // importDialog: false,
      recordDialog: false,
      hooksDialog: false,
      recordingURL: "",
      newPlan: true,
      selecteds: [],
      // selected: "",
      tab: 1,
      hooksMethod: "mail",
      hooksCondition: "fail",
      selectedHooks: [],
      hooksList: [
        { text: "Test Case", value: "plan" },
        { text: "E-Mail", value: "mail" },
      ],
      cancelToken: {} as CancelTokenSource,
      socket: io(config.SOCKET, {
        auth: {
          token: localStorage.getItem("p3t"),
        },
        transports: ["websocket"],
      }),
    };
  },
  computed: {
    debuggerOpen(): boolean {
      return this.$store.getters["Plans/getPlanDisplayDebugger"];
    },
    // debuggerViewOpen(): boolean {
    //   const currentResult = this.$store.getters["Results/getCurrentResultView"];
    //   return objNotEmpty(currentResult);
    // },
    progressText(): string {
      let text = "";
      const bar = Math.floor(this.compareTestResults / 20);

      switch (bar) {
        case 0:
          text = "Warming up!";
          break;
        case 1:
          text = "Lets Go!";
          break;
        case 2:
          text = "Yup! it's alive!";
          break;
        case 3:
          text = "Almost there...";
          break;
        case 4:
          text = "Wrapping up!";
          break;

        default:
          text = "Wrapping up!";
          break;
      }
      return text;
    },
    deleteStepSelected(): Step {
      return this.$store.getters["Plans/getDeleteStep"];
    },
    valid(): boolean {
      return this.plan?.name?.length > 0 && this.plan?.steps?.length > 0;
    },
    extension(): boolean {
      return this.$store.getters["getExtension"];
    },
    isRoutine(): boolean {
      return this.moduleType == PlanType.ROUTINE;
    },
    isSuper(): boolean {
      const { role } = this.$store.getters["Users/getUser"];
      return role <= RoleType.SUPER_ADMIN;
    },
    plan: {
      get(): Plan {
        const plan: Plan = this.$store.getters["Plans/getCurrentPlan"];
        // migrate from plan.test
        // if (!plan.steps?.length) {
        //   console.log("inside");
        //   plan.steps = [...plan.test];
        // }
        if (plan._id) {
          this.$store.commit("setTitle", `Edit '${plan.name}'`);
        }
        return plan;
      },
      set(val: Plan) {
        this.planChanged(val);
      },
    },
    debuggerRunning(): boolean {
      return (
        this.loading ||
        (Object.keys(this.results).length > 0 && !this.results.complete)
      );
    },
    compareTestResults(): number {
      if (!this.plan?.steps || !this.results?.results) {
        return 0;
      }
      return Math.floor(
        (this.flatRecursive(this.results.results).length /
          this.flatRecursive(this.plan.steps).length) *
          100
      );
    },
    results(): any {
      return this.$store.getters["Plans/getPlanCurrentDebugger"];
    },
    importItems(): SelectItem[] {
      const items = this.isRoutine ? this.routines : this.plans;
      return items;
    },
    importDialog: {
      get(): boolean {
        return this.$store.getters.getImportDialogActive;
      },
      set(val: boolean) {
        this.$store.commit("setImportDialogActive", val);
      },
    },
    exitDialog: {
      get(): boolean {
        return this.$store.getters.getExitDialog;
      },
      set(val: boolean) {
        this.$store.commit("setExitDialog", val);
      },
    },
    exitDialogTo: {
      get(): string {
        return this.$store.getters.getExitDialogTo;
      },
      set(val: string) {
        this.$store.commit("setExitDialogTo", val);
      },
    },
    labels(): string[] {
      const labels = this.$store.getters["Users/getUserLabels"] || [];
      return labels.map((label: string) => {
        return { text: capitalize(label), value: label };
      });
    },
    routines(): SelectItem[] {
      return this.$store.getters["Plans/getRoutines"];
    },
    plans(): SelectItem[] {
      // TODO add filter and exclude option for current
      let plans = this.$store.getters["Plans/getPlans"];
      if (this.plan._id) {
        plans = plans.filter((p: Plan) => p._id !== this.plan._id);
      }
      return plans.map((p: Plan) => {
        return {
          text: p.name,
          value: p._id,
          icon: "flask",
          type: "plan",
        };
      });
    },
    changed(): boolean {
      return this.$store.getters["Plans/getCurrentPlanChange"];
    },
    hooksItems() {
      this.selectedHooks = [];
      let items = [];

      switch (this.hooksMethod) {
        case "plan":
          items = this.plans;
          break;
        case "mail":
          items = this.contacts;
          break;

        default:
          break;
      }
      return items;
    },
    hooks() {
      return this.plan.callback || [];
    },
    passHooks() {
      return this.hooks.filter((h: any) => h.condition === "pass");
    },
    failHooks() {
      return this.hooks.filter((h: any) => h.condition === "fail");
    },
    contacts(): any {
      const contacts = this.$store.getters["Groups/getContacts"];
      return contacts.map((p: ContactItem) => {
        return {
          text: p.name,
          value: p.val,
          icon: "card-account-mail",
          type: "mail",
        };
      });
    },
    // activeEdit(): boolean {
    //   return this.$store.getters["Plans/getPlanCurrentTest"];
    // },
    validateURL(): boolean {
      return regexes.host.url.test(this.recordingURL);
    },
  },
  methods: {
    addNew(type = StepType.UI) {
      const step: Step = cloneObj(DefaultStep);
      step.type = type;
      step.id = v4();
      step.name = "Go To ";
      step.action = {
        method: type ? "url" : "get",
        url: "",
        type: type ? "misc" : "api",
      };
      this.addChild(step);
      // this.$store.dispatch("Plans/setPlanDisplayTest", test);
      // this.$store.commit("Plans/setPlanCurrentStep", step.id);
      // setTimeout(() => {
      //   scrollToID(step.id);
      // }, 100);
      // this.$nextTick(() => scrollToEnd(this.$el, "#planning"));
    },
    addChild(step: Step, selectStep = true) {
      this.plan.steps.push(step);
      if (selectStep) {
        this.$store.commit("Plans/setPlanCurrentStep", step.id);
      }
      setTimeout(() => {
        scrollToID(step.id);
      }, 100);
    },
    openPlanImportDialog() {
      this.$store.commit("setImportDialog", {
        active: true,
        items: this.plans,
        action: this.planImport,
        title: "Select Test Case to import",
      });
    },
    async addRoutine(item: SelectItem) {
      this.resetDebugger();
      const routine: Plan = await this.$store.dispatch(
        "Plans/fetchPlan",
        item.value
      );
      const step: Step = cloneObj(DefaultStep);
      step.id = v4();
      step.type = StepType.ROUTINE;
      step.name = routine.name;
      step.ref = routine._id;
      step.children = routine.steps;
      // step.action = {};
      this.addChild(step, false);
    },
    openRoutineImportDialog() {
      this.$store.commit("setImportDialog", {
        active: true,
        items: this.routines,
        action: this.addRoutine,
        title: "Select Test Routine to import",
      });
    },
    async planImport(selected: SelectItem) {
      this.resetDebugger();
      this.importDialog = false;
      if (selected) {
        const planMeta: any = selected;
        const planId: string = planMeta.value;
        const plan = await this.$store.dispatch("Plans/fetchPlan", planId);
        // parse env and steps into current plan
        const { steps, env } = plan;
        if (steps.length) {
          let clone = [];
          for (const step of steps) {
            clone.push(reId({ ...step }));
          }
          this.plan.steps = [...this.plan.steps, ...clone];
        }
        if (env.length) {
          for (const i in env) {
            const { name } = env[i];
            if (!this.plan.env.filter((e: any) => e.name === name).length) {
              this.plan.env.push(env[i]);
            }
          }
        }
        this.$store.dispatch("popMsg", {
          type: "info",
          content: `<strong>${plan.name}'s</strong> steps were imported successfully :)`,
          dismissible: true,
          timeout: 2000,
        });
      } else {
        this.$store.dispatch("popMsg", {
          type: "error",
          content: `Something went wrong... steps were not imported`,
          dismissible: true,
          timeout: 2000,
        });
      }
    },
    planChanged(newData: any | undefined = undefined) {
      if (newData) {
        const plan: any = this.plan;
        for (const key in newData) {
          plan[key] = cloneObj(newData[key]);
        }
        // console.log(plan);
      }
      // this.$store.commit("Plans/setCurrentPlan", this.plan);
      this.$store.commit("Plans/checkCurrentPlanChange");
    },
    // getDisplay() {
    //   this.displayStep = this.$store.getters["Plans/getPlanDisplayTest"];
    // },
    // setDisplay() {
    //   this.$store.dispatch("Plans/setPlanDisplayTest", this.displayStep);
    // },
    capitalize,
    async save() {
      await this.update();
      this.$router.push(this.routeRoot);
    },
    // resetDelete(): void {
    //   this.$store.commit("Plans/setDeleteStep");
    // },
    updateFailHooksList(list: any[]) {
      this.updateHooksList(list, "fail");
    },
    updatePassHooksList(list: any[]) {
      this.updateHooksList(list, "pass");
    },
    updateHooksList(list: any[], condition: string) {
      if (this.plan.callback?.length) {
        const filtered = this.plan.callback.filter(
          (h: any) => h.condition != condition
        );
        this.plan.callback = cloneObj([...filtered, ...list]);
      }
    },
    addHook() {
      if (this.plan.callback && this.selectedHooks.length) {
        const list: any[] = [];
        this.selectedHooks.forEach((hook: any) => {
          const newHook = cloneObj(hook);
          newHook.condition = this.hooksCondition;
          list.push(newHook);
        });
        this.plan.callback?.push(...list);
        this.selectedHooks = [];
      }
      this.hooksDialog = false;
    },
    openHooksDialog(conditions = "pass") {
      this.selectedHooks = [];
      this.hooksCondition = conditions;
      this.hooksDialog = true;
    },
    async update() {
      this.updating = true;
      this.plan.type = this.moduleType;
      this.$store.commit("Plans/updatePlanSnapshot");
      this.$store.commit("Plans/setCurrentPlanChange", false);
      await this.$store.dispatch("Plans/savePlan", this.plan);
      this.$store.dispatch("popMsg", {
        type: "info",
        content: `Test Case was updated successfully`,
        dismissible: true,
        timeout: 2000,
      });
      this.updating = false;
    },
    async genTemplate() {
      this.loading = true;
      this.$router.push("/templates");
      const plan = { ...this.plan };
      plan.type = PlanType.TEMPLATE;
      await this.$store.dispatch("Plans/generateTemplate", plan);
      this.$store.commit("Plans/updatePlanSnapshot");
      this.$store.commit("Plans/setCurrentPlanChange", false);

      this.loading = false;
    },
    changeTab(val: any) {
      const { hash } = this.$route;
      this.tab = val;
      switch (val) {
        case 2:
          if (hash != "#plan") {
            this.$router.push({ hash: "#plan" });
          }
          break;
        case 3:
          if (hash != "#hooks") {
            this.$router.push({ hash: "#hooks" });
          }
          break;
        default:
          if (hash != "#general") {
            this.$router.push({ hash: "#general" });
          }
          break;
      }
      this.$store.commit(
        "setTitle",
        this.plan?._id ? `Edit '${this.plan.name}'` : `Add New ${this.identity}`
      );
    },
    // fixObject() {
    //   if (!("callback" in this.plan)) {
    //     this.plan.callback = [];
    //   }
    //   if (
    //     this.plan.callback &&
    //     this.plan.callback?.length &&
    //     !this.selectedPassHooks.length &&
    //     !this.selectedFailHooks.length
    //   ) {
    //     this.selectedPassHooks = [
    //       ...this.plan.callback.filter((c: any) => c.condition === "pass"),
    //     ];
    //     this.selectedFailHooks = [
    //       ...this.plan.callback.filter((c: any) => c.condition === "fail"),
    //     ];
    //   }
    // },
    routeTo(method: string) {
      const { group } = this.$store.getters["Users/getUser"];
      window.location.pathname =
        method === "plan" ? "/plans/add" : "/group/settings/" + group;
    },
    fetchUrl(): string | undefined {
      const { test } = this.plan;
      if (!test?.length) {
        return;
      }
      const { url } = test.find((t: Step) => t.action.method === "url").action;
      return this.parseEnv(url, this.plan.env || []);
    },
    parseEnv,
    preperRecorder() {
      const url = this.fetchUrl();
      if (!url) {
        return (this.recordDialog = true);
      }
      this.startRecording(url);
    },
    startRecording(url: string) {
      const { steps } = this.plan;
      const data = {
        url,
        steps,
      };
      const event = new CustomEvent("startRecording", { detail: data });
      document.dispatchEvent(event);
    },
    stopRecording(data: any) {
      const event = new CustomEvent("stopRecording", { detail: data });
      document.dispatchEvent(event);
    },
    // pauseRecording(data: any) {
    //   const event = new CustomEvent("pauseRecording", { detail: data });
    //   document.dispatchEvent(event);
    // },
    flatRecursive,
    resetDebugger() {
      this.$store.commit("Plans/setPlanCurrentStep");
      this.$store.commit("Plans/setPlanCurrentDebugger");
      this.$store.commit("Results/setCurrentResultView");
    },
    async runPlan() {
      this.tab = 2;
      this.loading = true;
      // this.$store.commit("Plans/setPlanDisplayTest", false);
      this.$store.commit("toggleExpand", true);
      this.resetDebugger();
      this.$store.commit("Plans/setPlanDisplayDebugger", true);
      this.cancelToken = genCancelToken();
      const { resultId } = await this.$store.dispatch("Plans/run", {
        id: this.plan._id,
        debug: true,
        cancelToken: this.cancelToken.token,
      });
      this.socket.emit("result_view", resultId);
      // this.$store.commit("Plans/setPlanCurrentDebugger", results);
    },
    next() {
      this.tab++;
    },
    tabUpdate(tab: number) {
      this.tab = tab;
    },
  },
  // watch: {
  //   hooksMethod() {
  //     this.callbacks = [];
  //   }
  // },

  created() {
    this.$store.commit("Plans/setCurrentPlan");
  },
  async mounted() {
    this.$store.commit("setGlobalLoader", true);
    const { meta, params, hash } = this.$route;
    this.moduleType = meta.type || PlanType.PLAN;
    this.routeRoot = meta.routeRoot || "/plans";
    switch (this.moduleType) {
      case PlanType.ROUTINE:
        this.identity = "Test Routine";
        break;
      case PlanType.TEMPLATE:
        this.identity = "Template";
        break;

      default:
        this.identity = "Test Case";
        break;
    }
    this.$store.dispatch("Groups/fetchGroupContacts");
    this.$store.dispatch(
      "Plans/fetchAllPlans",
      { type: PlanType.PLAN },
      false,
      false
    );
    this.$store.dispatch(
      "Plans/fetchAllRoutines",
      { type: PlanType.ROUTINE },
      false,
      false
    );
    this.$store.dispatch(
      "Plans/fetchAllAuthMethods",
      { type: PlanType.ROUTINE, isAuthMethod: true , limit:10},
      false,
      false
    );
    // this.$store.commit("Plans/setPlanDisplayTest", false);
    // this.$store.commit("Plans/setPlanCurrentDebugger");
    this.resetDebugger();
    this.$store.commit("Plans/setPlanDisplayDebugger", false);
    const { id } = params;
    if (id) {
      this.newPlan = false;
      const plan = await this.$store.dispatch("Plans/fetchPlan", id);
      if (!plan) {
        const msg: Msg = {
          id: v4(),
          type: "error",
          content: `Test Case ID - not valid`,
          dismissible: true,
          timeout: 2000,
          notify: true,
        };
        this.$store.dispatch("popMsg", msg);
        this.$router.push("/");
      }
      this.$store.commit("Plans/setCurrentPlan", plan);
      switch (hash) {
        case "#routine":
          this.tab = 2;
          break;
        case "#plan":
          this.tab = 2;
          break;
        case "#hooks":
          this.tab = 3;
          break;

        default:
          this.tab = 1;
          break;
      }
    }
    this.$store.commit("setGlobalLoader");
    this.socket.on("resultsObj", (resultsObj: any) => {
      this.$store.commit("Plans/setPlanCurrentDebugger", resultsObj);
      this.loading = false;
    });
    this.socket.on("resultsData", (data: any) => {
      let results = { ...this.results };
      results = { ...results, ...data };
      this.$store.commit("Plans/setPlanCurrentDebugger", results);
    });
    console.log(this.plan);
  },
  updated() {
    this.$store.commit("Plans/checkCurrentPlanChange");
  },
  beforeRouteLeave(to, _, next) {
    if (this.changed && !this.exitDialog) {
      this.exitDialogTo = to.fullPath;
      this.exitDialog = true;
      return;
    }
    next();
  },
  destroyed() {
    if (this.cancelToken.cancel) this.cancelToken.cancel();
    this.exitDialog = false;
    // this.$store.commit("Plans/setPlanDisplayTest", false);
    this.$store.commit("Plans/setCurrentPlanChange", false);
    this.$store.commit("Plans/setCurrentPlan");
  },
});
</script>

<style scoped>
.absolute {
  margin: 0 auto;
  position: absolute;
  top: 20vh;
  left: 0;
  right: 0;
  width: 50vw;
}
#innerRun {
  top: -10px;
  width: fit-content;
  left: auto;
  right: 0;
  z-index: 1;
}
.actions2 {
  position: absolute;
  z-index: 999;
  left: -3px;
  bottom: -20px;
  opacity: 0;
  transition: "opacity" 2.5s ease;
}
.actions2:hover,
.section:hover > .actions2 {
  opacity: 1;
  display: block;
}
.helper {
  position: absolute;
  bottom: 1vh;
  width: 50vw;
  margin: 0 auto;
  right: 0;
  left: 0;
  border: 2px solid rgba(0, 128, 128, 0.658) !important;
}
.v-stepper__header {
  height: auto;
  box-shadow: none;
}
.v-stepper__step {
  padding-top: 5px;
  padding-bottom: 5px;
}
.fw {
  width: 100%;
}
</style>
